import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Cookie } from "lucide-react";

const KEY = "a3-cookie-consent";

export function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (localStorage.getItem(KEY)) return;
    const t = setTimeout(() => setVisible(true), 1200);
    return () => clearTimeout(t);
  }, []);

  const choose = (value) => {
    localStorage.setItem(KEY, value);
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 40 }}
          transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
          className="glass-strong fixed bottom-5 left-5 z-[60] w-[calc(100vw-2.5rem)] max-w-sm rounded-2xl p-5 shadow-2xl"
          data-testid="cookie-consent"
        >
          <div className="flex items-start gap-3">
            <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-brand-cyan/15 text-brand-cyan">
              <Cookie className="h-5 w-5" />
            </div>
            <div>
              <p className="font-display text-sm font-semibold text-white">We value your privacy</p>
              <p className="mt-1 text-xs leading-relaxed text-white/55">
                We use cookies to improve your experience, analyse traffic and personalise content. Choose how we may use them.
              </p>
            </div>
          </div>
          <div className="mt-4 flex gap-2">
            <button
              onClick={() => choose("all")}
              className="flex-1 rounded-full bg-gradient-to-r from-brand-blue to-brand-cyan px-4 py-2.5 text-xs font-semibold text-[#08120A] transition-shadow hover:shadow-[0_0_20px_rgba(198,255,58,0.4)]"
              data-testid="cookie-accept"
            >
              Accept All
            </button>
            <button
              onClick={() => choose("essential")}
              className="flex-1 rounded-full border border-white/15 bg-white/5 px-4 py-2.5 text-xs font-medium text-white transition-colors hover:border-brand-cyan/50"
              data-testid="cookie-essential"
            >
              Essential Only
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
